/**
 * Uint16 constants
 *
 * @see https://voltaire.tevm.sh/primitives/uint16 for Uint16 documentation
 * @since 0.0.0
 */

/** @type {import('./Uint16Type.js').Uint16Type} */
export const MIN = /** @type {any} */ (0);

/** @type {import('./Uint16Type.js').Uint16Type} */
export const MAX = /** @type {any} */ (65535);

/** @type {import('./Uint16Type.js').Uint16Type} */
export const ZERO = /** @type {any} */ (0);

/** @type {import('./Uint16Type.js').Uint16Type} */
export const ONE = /** @type {any} */ (1);

/** @type {number} */
export const SIZE = 16;
